import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle, DeliveryTruck } from 'iconoir-react';
import clsx from 'clsx';
import { useFormatMoneyAmount } from '@lib/hooks/use-format-money-amount';
import { useCatalogTranslation } from '@lib/hooks/use-catalog-translations';

const CartFranco: React.FC<{
  franco: number;
  total: number;
  freeShipping: boolean;
  fullVersion: boolean;
}> = ({ franco, total, freeShipping, fullVersion }) => {
  const { ct } = useCatalogTranslation('cart');
  const { i18n } = useTranslation();
  const formatMoneyAmount = useFormatMoneyAmount();

  const messages = useMemo(
    () => ({
      freeShippingDiscount: ct(
        'CartFranco.freeShippingDiscount',
        'Promtion: la livraison st offerte !',
      ),
      raised: ct(
        'CartFranco.raised',
        'Vous avez atteint votre FRANCO. Profitez de la livraison offerte !',
      ),
      freeShippingFrom: ct(
        'CartFranco.freeShippingFrom',
        'Livraison offerte à partir de ',
      ),
      remainingAmount1: ct('CartFranco.remainingAmount_part1', 'Plus que'),
      remainingAmount2: ct(
        'CartFranco.remainingAmount_part2',
        'avant la livraison gratuite',
      ),
    }),
    [i18n.language],
  );

  const isFrancoReached = useMemo(() => franco - total <= 0, [franco, total]);

  return (
    <div
      className={clsx('text-grey2-60 rounded-xl', {
        'bg-seller/5 py-4 px-6': fullVersion,
        'bg-white px-3 pt-3': !fullVersion,
      })}
      data-testid="franco"
    >
      {isFrancoReached ? (
        <div
          className={clsx('flex items-center', {
            'gap-4': fullVersion,
            'gap-2': !fullVersion,
          })}
        >
          <CheckCircle
            className={clsx('text-seller', {
              'h-8 w-8': fullVersion,
              'h-6 w-6': !fullVersion,
            })}
          />
          <div className="text-sm">
            <span>
              {freeShipping ? messages.freeShippingDiscount : messages.raised}
            </span>
          </div>
        </div>
      ) : (
        <div
          className={clsx('flex items-center ', {
            'gap-4 sm:gap-5': fullVersion,
            'gap-2': !fullVersion,
          })}
        >
          <DeliveryTruck
            className={clsx(' text-grey2--90', {
              'h-8 w-8': fullVersion,
              'h-6 w-6': !fullVersion,
            })}
          />
          <div className="text-sm text-normal">
            {fullVersion && (
              <div>
                <span>{messages.freeShippingFrom}</span>
                <span className="font-bold">{formatMoneyAmount(franco)}</span>
              </div>
            )}
            <div>
              <span>{messages.remainingAmount1} </span>
              <span className="font-bold text-seller">
                {formatMoneyAmount(franco - total)}
              </span>
              <span>{` ${messages.remainingAmount2}`}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartFranco;
